<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.contractingAuthority.history.title"> </sm-page-header>
  <div class="content">
    <div class="flex items-center gap-2">
        <sm-form-builder [formObject]="formObject"></sm-form-builder>
        <p-button 
            [label]="'settings.contractingAuthority.history.search' | translate" 
            (click)="confirm()" 
            class="mt-11" 
            [disabled]="isSearchDisabled$ | async"
        ></p-button>
    </div>
    <sm-data-table-builder [datas]="data" [loading]="loading" [dataTableObject]="dataTableObject"></sm-data-table-builder>
  </div>